export const slideQueryKeys = {
    resting: 0 /* SlideIndex.Resting */,
    map: 1 /* SlideIndex.Map */,
    logoOnly: 2 /* SlideIndex.LogoOnlyStart */,
    welcome: 3 /* SlideIndex.Welcome */,
    thankYou: 4 /* SlideIndex.ThankYou */,
    standStrongPodcast: 5 /* SlideIndex.StandStrongPodcast */,
    guestSpeakers: 6 /* SlideIndex.GuestSpeakers */,
    gospelMeeting: 7 /* SlideIndex.GospelMeeting */,
    gospelMeetingTemp: 8 /* SlideIndex.GospelMeetingTemp */,
    informer: 9 /* SlideIndex.Informer */,
    members: 10 /* SlideIndex.Members */,
    website: 11 /* SlideIndex.Website */,
    worshipTimes: 12 /* SlideIndex.WorshipTimes */,
    worshipPointer: 13 /* SlideIndex.WorshipPointer */,
    upcomingBibleClass: 14 /* SlideIndex.UpcomingBibleClassAnnouncements */,
    currentBibleClass: 15 /* SlideIndex.CurrentBibleClassAnnouncements */,
};
